import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import "../pages/home.css";

import heroVideo from "../assets/hero1.mp4";

import Carousel1 from "./category.js";
import About from "./about.js";
import Contact from "./contact.js";
import OfferDisplay from "../components/OfferDisplay.js";

import { setPageMeta } from "../utils/seo";

const Home = () => {

  useEffect(() => {
    setPageMeta({
      title: "Banat India | Premium Toothbrushes & Oral Care",
      description:
        "Discover Banat India toothbrushes for kids, adults, and seniors.",
      keywords:
        "Banat India, toothbrush, oral care, dental hygiene, premium toothbrushes",
    });
  }, []);

  return (
    <>
      {/* HERO SECTION */}

      <section className="hero-section">
        <div className="hero-slide">

          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src={heroVideo} type="video/mp4" />
          </video>

          <div className="hero-overlay">

            <div className="hero-content">

              <span className="hero-tag">
                Premium Oral Care
              </span>

              <h1>
                Smile Brighter <br />
                Every Day
              </h1>

              <p>
                Discover premium toothbrushes crafted for comfort,
                style and healthier smiles.
              </p>

              <Link to="/shop">
                <button className="hero-btn">
                  Explore Collection
                </button>
              </Link>

            </div>

          </div>

        </div>
      </section>

      {/* OFFERS */}

      <div className="home-offers">
        <OfferDisplay showAll={true} />
      </div>

      <About />
      <Carousel1 />
      <Contact />
    </>
  );
};

export default Home;

